import { useAsyncData } from '#imports'

import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import { useMasterPP } from '~/scopes/product/composables/useMasterPP/useMasterPP'
import { useUrlParams } from '~/scopes/product/composables/useUrlParams'

export function useFetchProduct() {
  const { productId } = useUrlParams()
  const $httpFetch = useHttpFetch()
  const { isMasterPPUrl } = useMasterPP()

  return useAsyncData(
    `pp-product-${productId}`,
    async () =>
      await $httpFetch('/product-page/products/:productId', {
        pathParams: { productId },
        query: {
          withVisiblePartnership: true,
        },
      }),

    {
      default: () => undefined,
      transform: (p: GetProductResponse) => {
        if (isMasterPPUrl.value) {
          return {
            ...p,
            titles: {
              ...p.titles,
              raw: p.titles.default,
            },
          }
        }

        return p
      },
      dedupe: 'defer',
    },
  )
}
